import React from 'react'
import { Tabs, Tab } from '@mui/material';

const ScheduleOrderTabs = ({ selectedTab, handleChange }) => {
    return (
        <Tabs
            value={selectedTab}
            onChange={handleChange}
            aria-label="customer tabs"
            sx={{
                color: '#512DA8',
                backgroundColor: '#fff',
                width: '100%',
                boxShadow: '0px -1px 0px 0px #E8E8E8 inset',
                '& .MuiTabs-indicator': {
                    backgroundColor: '#512DA8',
                },
                '& .MuiTab-root': {
                    fontSize: '16px',
                    textTransform: 'capitalize',
                    color: '#585757', // Default color for all tabs
                },
                '& .Mui-selected': {
                    fontSize: '16px',
                    textTransform: 'capitalize',
                    color: '#512DA8 !important', // Color for the selected tab
                    borderRadius: '0px',
                },
            }}
        >
            <Tab label="Total Orders" sx={{
                color: selectedTab === 0 ? '#FFFFFF' : '#512DA8',
                borderRadius: '8px',
            }} />
            <Tab label="Pending Orders" value="1" />
            <Tab label="Upcoming Shipments" value="2" />
            <Tab label="Rescheduled Shipments" value="3" />
            <Tab label="Completed Orders" value="4" />
            <Tab label="Cancelled Orders" value="5" />
        </Tabs>
    )
}

export default ScheduleOrderTabs